/*
 view-currencyselect.js
 */
import actions from '../../common/lib/utils/actions.js';
import core from '../../common/lib/core.js';
import viewTextkeys from '../../commonview/lib/view-textkeys.js';

const create = core.create; // creates basic elements not inserted into the dom
const nodetree = core.nodetree; // inserts an array of elements into a document-fragment which later may be inserted into the dom
const classnameShow = 'u-show';
const classnameHide = 'u-hide';

function createSelect(eventFilter) {
	const cName = `${eventFilter} payment__select`;
	return create({
		type: 'select',
		class: cName
	});
}

function createLegend(txt = '') {
	const elm = create({
		type: 'legend',
		class: 'legend'
	});
	elm.innerHTML = txt;
	return elm;
}

function createOptions(p) {
	/* see input format above */
	// obj, keytoval, keytotext, selectedId
	const arr = p.arr;
	const keytoval = p.keytoval;
	const keytotext = p.keytotext;
	const selectedCurrencyValue = (p.selectedCurrencyValue || null);
	const nodes = [];
	if (arr && arr.forEach) {
		arr.forEach((obj) => {
			/* A reference to the element is saved. */
			const elm = create({
				type: 'option',
				class: 'payment__option',
				value: (obj[keytoval] || (`${keytoval} missing`))
			});
			elm.innerHTML = (obj[keytotext] || (`${keytoval} missing`));
			if (selectedCurrencyValue) {
				if (obj.value && obj.value === selectedCurrencyValue) {
					elm.selected = true;
				}
			} else if (obj.selected) {
				elm.selected = true;
			}
			/* The uninserted nodes are returned as a list to be inserted with 'nodetree'-function. */
			nodes.push(elm);
		});
	}
	return nodes;
}

function valueToOptionIndex(num, arr, attr = 'value') {
	let arrIndex = null;
	const numToStr = num.toString();
	arr.forEach((elm, index) => {
		if (elm.getAttribute && elm.getAttribute(attr) && elm.getAttribute(attr) === numToStr) {
			arrIndex = index;
		}
	});
	return arrIndex;
}

function mainHandler(e, onEventCb, eventFilterSeparatorClassname) {
	/* this handler is a wrapper that filters out values from the target element,
	and then applies the callback-argument on these values */
	const eventFilterSelector = `.${eventFilterSeparatorClassname}`;

	function cb(p) {
		p.e.stopPropagation();
		/* get method from the selectbox */
		const selectElm = p.elm;
		const selectedOptionIndex = selectElm.selectedIndex;
		const optionElm = selectElm[selectedOptionIndex];
		const value = optionElm.value;
		const text = optionElm.text;
		onEventCb({
			value,
			text
		});
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	core.handle(e, eventFilterSelector, cb, true);
}

function addListeners(elm, cbOnEvent, eventFilter, eventType) {
	function handleCreator(e) {
		mainHandler(e, cbOnEvent, eventFilter);
	}
	core.addListener(elm, eventType, handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler, eventType) {
	if (elm) {
		core.removeListener(elm, eventType, handler);
	}
}

function show(elm) {
	if (elm) {
		core.removeClass(elm, classnameHide);
		core.addClass(elm, classnameShow);
	}
}

function hide(elm) {
	core.removeClass(elm, classnameShow);
	core.addClass(elm, classnameHide);
}

function getSelectedIndex(arr) {
	let key = null;
	if (arr && arr.forEach) {
		arr.forEach((elm, index) => {
			if (elm.selected) {
				key = index;
			}
		});
	}
	return key;
}

export default {
	create() {
		let elements = {};
		const mainEventType = 'change';
		const classNameEventFilter = 'js-eventfilter-viewselect';
		const textkeysObj = viewTextkeys.depositflow();
		elements.fieldset = (elements.fieldset || create('fieldset', 'custom-select u-relative u-mb2 u-show'));
		elements.legend = (elements.legend || createLegend(textkeysObj['select-currency']));
		elements.select = (elements.select || createSelect(classNameEventFilter));

		elements.fieldset.appendChild(elements.legend);
		elements.fieldset.appendChild(elements.select);
		elements.wrap = elements.fieldset;


		function callbackOnMainEvent(p) {
			const val = p.value;
			const text = p.text;
			console.log('view-select:callbackOnMainEvent', val, text);
			actions.viewCurrencySelect(val, text);
			/* change: updates less times than input: filter value and publish*/
			// const val = elements.inputamount.value;
			// const digits = validateAmount.keepDigits(val);
			// publishOrFeedback(digits, elements.amountfeedback, elements.inputamount);
		}
		const handler = addListeners(elements.wrap, callbackOnMainEvent, classNameEventFilter, mainEventType);
		return {
			wrap: elements.wrap,
			show() {
				show(elements.wrap);
			},
			hide() {
				hide(elements.wrap);
			},
			update(state) {
				/* this module accepts the format:
				{'name1':[{'value':'some text'}, ... 'nameN':{'value':'some text other'}]}
				 */
				if (state && state.fetch_methoddetails.currencies) {
					const currencies = state.fetch_methoddetails.currencies;
					const selectedCurrencyValue = state.fetch_methoddetails.lastUsedAccountIdx != null ? state.fetch_methoddetails.accounts[state.fetch_methoddetails.lastUsedAccountIdx].cu : null;
					const selectedIndex = getSelectedIndex(currencies);
					let optIndex = null;
					if (Array.isArray(currencies)) {
						// TODO: this should only update when a new list of preset amounts is available
						if (elements.options && (selectedIndex || selectedIndex === 0)) {
							/* update selected option if the list list is refreshed programatically */
							if (selectedCurrencyValue != null) {
								optIndex = valueToOptionIndex(selectedCurrencyValue, elements.options);
							} else {
								optIndex = selectedIndex;
							}

							if (elements.options[optIndex]) {
								elements.options[optIndex].selected = true;
							}
						} else {
							elements.options = createOptions({
								arr: currencies,
								keytoval: 'value',
								keytotext: 'text',
								selectedCurrencyValue
							});

							elements.select.appendChild(nodetree(elements.options));
						}
					}
				}
			},
			close() {
				/* hide the spinner if the spinner is closed before hidden.
				Otherwise the '.dim' element will remain on the parent */
				removeListeners(elements.wrap, handler, mainEventType);
				elements = core.deleteElementsInObjectExcept(elements, [], 'view_amountselect:248');
				return null;
			}
		};
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/view-currencyselect.js